import { BYO_ERRORS_SHOW_EVENT_LEVEL, BYO_ERRORS_HIDE_EVENT_LEVEL, BYO_ERRORS_CLEAN_ALL, BYO_SLIP_SELECTION_INCOMPATIBLE_ERROR, BYO_ADD_TO_BETSLIP_ERROR, } from '../constants';
export const showEventLevelError = (message) => ({
    type: BYO_ERRORS_SHOW_EVENT_LEVEL,
    payload: message
});
export const hideEventLevelError = () => ({
    type: BYO_ERRORS_HIDE_EVENT_LEVEL
});
export const addSelectionIncompatibleError = (error) => ({
    type: BYO_SLIP_SELECTION_INCOMPATIBLE_ERROR,
    payload: error
});
export const cleanErrors = () => ({
    type: BYO_ERRORS_CLEAN_ALL
});
export const addToBetslipError = (errorType = 'BYO_ERROR') => ({
    type: BYO_ADD_TO_BETSLIP_ERROR,
    payload: errorType,
});
